import useCyclesApprove from '@plug-core/hooks/useCyclesApprove'
import { logger } from '@plug-core/logger'
import { sanitizeDecimalInput } from '@plug-core/utils/validationHelper'
import { Button, Heading, Input, Text } from '@ui'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  hideSelf: () => void
}

const ApproveCycles: FC<Props> = ({ hideSelf }) => {
  const { amount, setAmount, walletCyclesBalance, approve, error, approveLoading } =
    useCyclesApprove()

  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-4">
      <Heading level={4} align="center">
        {t('common.approve')}
      </Heading>
      <Input
        value={amount}
        onChange={(e) => {
          sanitizeDecimalInput(e.target.value, setAmount)
        }}
        aria-label={t('common.approve')}
        trailing={<Text as="span">{walletCyclesBalance?.token.symbol}</Text>}
        autoFocus
      />
      <Button
        variant="primary"
        onClick={() =>
          approve()
            .then(() => hideSelf())
            .catch(logger.debug)
        }
        disabled={!!error}
        loading={approveLoading}
        fullWidth
      >
        {error || t('common.approve')}
      </Button>
    </div>
  )
}

export default ApproveCycles
